module.exports = __webpack_public_path__ + "static/media/paper-plane-tilt-fill.9270883f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/website-bot/img/paper-plane-tilt-fill.webp
// module id = 438
// module chunks = 0